import React from 'react';
import UserMenu from '../auth/UserMenu';
import CompanySelector from './CompanySelector';
import { useAuth } from '../../hooks/useAuth';
import LoadingSpinner from '../common/LoadingSpinner';

const Header: React.FC = () => {
  const { isAuthenticated, isLoading, user } = useAuth();

  return (
    <header
      className="sticky top-0 z-30 flex items-center justify-between px-8"
      style={{
        height: 'var(--space-header-height)',
        minHeight: 'var(--space-header-height)',
        backgroundColor: 'var(--color-surface-header)',
        borderBottom: '1px solid var(--color-border-subtle)',
        boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
      }}
    >
      {/* Left side - Logo (mobile only) */}
      <div className="flex items-center">
        <span className="text-xl font-semibold lg:hidden" style={{ color: 'var(--color-brand-primary)' }}>
          Hub Shoppub
        </span>
      </div>

      {/* Right side - Company Selector and User Menu */}
      <div className="flex items-center gap-3">
        {isAuthenticated && user && <CompanySelector />}
        {isLoading ? (
          <LoadingSpinner size="small" />
        ) : isAuthenticated && user ? (
          <UserMenu />
        ) : (
          <div className="text-sm" style={{ color: 'var(--color-text-secondary)' }}>Não autenticado</div>
        )}
      </div>
    </header>
  );
};

export default Header;
